import { SvgIcon } from '@material-ui/core';
import { ReactComponent as ribbon } from './ribbon.svg';

export default function Ribbon(props) {
  return <SvgIcon {...props} component={ribbon} viewBox="0 0 260 59" />;
}
